import React, { useState, useEffect, Fragment } from 'react';
import { useAlert } from "react-alert";
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Box, Card, Grid, TextField, makeStyles, Button, CardContent, Divider, InputLabel, MenuItem, Chip
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate, useParams } from 'react-router-dom';
import { LoadingComponent } from '../../../../utils/newLoader';
import { AlertDialog } from '../../../Common/AlertDialog';
import lodash from 'lodash';


const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecord: {
        backgroundColor: "green",
    },
    bold: {
        fontWeight: 600,
    }

}));

const screenCode = 'BALANCESHEETREPORT';

export default function BalanceSheetSectionCreation(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { groupID } = useParams();
    const { factoryID } = useParams();
    const classes = useStyles();
    const [title, setTitle] = useState("Balance Sheet Setup");
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
    });
    
    const handleClickNavigate = () => {
        navigate('/app/balanceSheet/balanceSheetReport');
    }
    
    const [BalanceSheetDetails, setBalanceSheetDetails] = useState({
        groupID: 0,
        factoryID: 0,
        parentSectionID: '0',
        subSectionName: ''
    });

    const [ParentSectionNameList, setParentSectionNameList] = useState();
    const [CreatedSectionNameList, setCreatedSectionNameList] = useState();

    const [message, setMessage] = useState("  Are you sure you want to delete?");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [SectionIdToRemove, setSectionIdToRemove] = useState(0);

    useEffect(() => {
        trackPromise(getPermission());
        trackPromise(GetBalanceSheetParentSectionDetails());
    }, []);

    useEffect(() => {
        const DecryptedGroupID = atob(groupID.toString());
        const DecryptedFactoryID = atob(factoryID.toString());

        setBalanceSheetDetails({
            ...BalanceSheetDetails,
            groupID: DecryptedGroupID,
            factoryID: DecryptedFactoryID
        })

    }, [])


    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'ENABLEBALANCESHEETCONFIGURATION');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });
    }

    async function GetBalanceSheetParentSectionDetails() {
        const response = await services.GetBalanceSheetParentSectionDetails(BalanceSheetDetails.groupID, BalanceSheetDetails.factoryID)
        setParentSectionNameList(response)
    }

    async function SaveBalanceSheetSetupDetails() {
        let requestModel = {
            groupID: parseInt(BalanceSheetDetails.groupID),
            factoryID: parseInt(BalanceSheetDetails.factoryID),
            parenSectionID: parseInt(BalanceSheetDetails.parentSectionID),
            subSectionName: BalanceSheetDetails.subSectionName.toString(),
            createdBy: parseInt(tokenService.getUserIDFromToken()),
        }

        const response = await services.SaveBalanceSheetSubSectionCreation(requestModel)

        if (response.statusCode == "Success") {
            trackPromise(GetBalanceSheetCreatedSectionDetails(BalanceSheetDetails.parentSectionID))
            alert.success(response.message);
            ClearAllArrays()
        }
        else {
            alert.error(response.message);
        }
    }

    function ClearAllArrays() {
        setBalanceSheetDetails({
            ...BalanceSheetDetails,
            subSectionName: ''
        });
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setBalanceSheetDetails({
            ...BalanceSheetDetails,
            [e.target.name]: value
        });
    }

 async function GetBalanceSheetCreatedSectionDetails(parentSectionID) {
    const response = await services.GetBalanceSheetCreatedSectionDetails(
        parentSectionID, 
        BalanceSheetDetails.groupID, 
        BalanceSheetDetails.factoryID
    );
    if (response.data !== null && response.data.length > 0) {
        var result = lodash(response.data)
            .groupBy(x => x.balanceSheetParentSectionName)
            .map((value, key) => ({ balanceSheetParentSectionName: key, dataList: value }))
            .value();
        setCreatedSectionNameList(result);
    } else {
        setCreatedSectionNameList([]); 
    }
}

    async function HandleDelete(e) {
        setSectionIdToRemove(parseInt(e.toString()))
        setEnableConfirmMessage(true)
    }

    function confirmData(y) {
        if (y) {
            trackPromise(InActiveBalanceSheetSections())
        }
    }

    async function InActiveBalanceSheetSections() {
        let requestModel = {
            balanceSheetSectionID: parseInt(SectionIdToRemove.toString()),
            modifiedBy: parseInt(await tokenService.getUserIDFromToken().toString())
        }
        const response = await services.InActiveBalanceSheetSections(requestModel)

        if (response.statusCode == "Success") {
            alert.success(response.message);
            trackPromise(GetBalanceSheetCreatedSectionDetails(BalanceSheetDetails.parentSectionID))
        }
        else {
            alert.error(response.message);
        }
    }

    return (
        <Fragment>
            <LoadingComponent />
            <Formik
                initialValues={{
                    parentSectionID: BalanceSheetDetails.parentSectionID,
                    subSectionName: BalanceSheetDetails.subSectionName
                }}
                validationSchema={
                    Yup.object().shape({
                        parentSectionID: Yup.number().required('Parent Section Name is required').min("1", 'Parent Section Name is required'),
                        subSectionName: Yup.string().required('Section Name is required'),
                    })
                }
                onSubmit={() => trackPromise(SaveBalanceSheetSetupDetails())}
                enableReinitialize
            >
                {({
                    errors,
                    handleBlur,
                    handleSubmit,
                    touched
                }) => (
                    <form onSubmit={handleSubmit}>
                        <Box mt={0}>
                            <Card>
                                <PerfectScrollbar>
                                    <Divider />
                                    <CardContent>
                                        <Grid container spacing={3}>
                                            <Grid item md={4} xs={12}>
                                                <InputLabel shrink id="parentSectionID">
                                                    Parent Section Name *
                                                </InputLabel>
                                                <TextField select
                                                    error={Boolean(touched.parentSectionID && errors.parentSectionID)}
                                                    fullWidth
                                                    helperText={touched.parentSectionID && errors.parentSectionID}
                                                    size='small'
                                                    name="parentSectionID"
                                                    onBlur={handleBlur}
                                                    onChange={(e) => {
                                                        handleChange(e)
                                                        trackPromise(GetBalanceSheetCreatedSectionDetails(e.target.value))
                                                    }}
                                                    value={BalanceSheetDetails.parentSectionID}
                                                    variant="outlined"
                                                    id="parentSectionID"
                                                >
                                                    <MenuItem value="0">--Select Parent Section Name--</MenuItem>
                                                    {generateDropDownMenu(ParentSectionNameList)}
                                                </TextField>
                                            </Grid>
                                            <Grid item md={4} xs={12}>
                                                <InputLabel shrink id="subSectionName">
                                                    Section Name *
                                                </InputLabel>
                                                <TextField
                                                    error={Boolean(touched.subSectionName && errors.subSectionName)}
                                                    fullWidth
                                                    helperText={touched.subSectionName && errors.subSectionName}
                                                    size='small'
                                                    name="subSectionName"
                                                    onBlur={handleBlur}
                                                    onChange={(e) => {
                                                        handleChange(e)
                                                    }}
                                                    value={BalanceSheetDetails.subSectionName}
                                                    variant="outlined"
                                                    id="subSectionName"
                                                />
                                            </Grid>

                                        </Grid>
                                        <Box display="flex" flexDirection="row-reverse" p={2} >
                                            <Button
                                                color="primary"
                                                type="submit"
                                                variant="contained"
                                            >
                                                Create
                                            </Button>
                                        </Box>
                                        <Box style={{ marginTop: '0.5rem', marginLeft: "20%" }}>
                                            {
                                                CreatedSectionNameList !== undefined ?
                                                    CreatedSectionNameList.map((objNew) =>
                                                        <Grid Grid container spacing={1}>
                                                            <Typography variant='h5' style={{ marginLeft: "10rem" }} align="left">
                                                                <Chip label={objNew.balanceSheetParentSectionName} />
                                                            </Typography>
                                                            {
                                                                objNew.dataList !== undefined ?
                                                                    objNew.dataList.map((object) =>
                                                                        <Grid Grid container spacing={1} style={{ marginTop: '0.1rem' }}>
                                                                            <Grid item md={9} xs={12} >
                                                                                <Typography style={{ marginLeft: "15rem" }} align="left">
                                                                                    <Chip
                                                                                        label={object.balanceSheetSectionName}
                                                                                        key={object.balanceSheetSectionID}
                                                                                        variant="outlined"
                                                                                        deleteIcon={
                                                                                            <DeleteIcon
                                                                                                style={{
                                                                                                    color: "red",
                                                                                                    cursor: "pointer"
                                                                                                }}
                                                                                            />
                                                                                        }
                                                                                        onDelete={() => trackPromise(HandleDelete(object.balanceSheetSectionID))}
                                                                                    />
                                                                                </Typography>
                                                                            </Grid>
                                                                        </Grid>
                                                                    )
                                                                : null
                                                            }
                                                        </Grid>
                                                    )
                                                  : null
                                            }
                                        </Box>
                                        <div hidden={true}>
                                            <Grid item>
                                                <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage} setViewPopup={setEnableConfirmMessage} />
                                            </Grid>
                                        </div>
                                    </CardContent>
                                </PerfectScrollbar>
                            </Card>
                        </Box>
                    </form>
                )}
            </Formik>
        </Fragment>
    );
}